import { JSX, Show, For } from "solid-js";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";

/**
 * Similar Brands section with horizontal carousel
 */
export function SimilarBrandsSection(): JSX.Element {
  const { onBrandClick, getSimilarBrands } =
    useBrandl2WebstoreTelescopeContext();

  // const similarBrands = () => routeData().similarBrands || [];

  return (
    <Show when={getSimilarBrands().length > 0}>
      <div class="flex w-full flex-col gap-6">
        {/* Section Header */}
        <h2 class="text-title-4-semi-bold text-text-normal-primary">
          Similar gift cards
        </h2>

        {/* Brands Grid - Horizontal scroll on mobile, grid on desktop */}
        <div class="grid grid-cols-3 gap-4 lg:grid-cols-4">
          <For each={getSimilarBrands().slice(0, 8)}>
            {(brand) => (
              <div class="shrink-0 sm:w-auto">
                <SimilarGcListingCard
                  imageUrl={brand.brandThumbnailUrl}
                  name={brand.brandTitle}
                  discountPercentage={brand.discountPercentage}
                  onClick={() => onBrandClick(brand.brandKey)}
                  categoryName={brand.brandCategory}
                />
              </div>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}

export type SimilarGcListingCardProps = {
  imageUrl: string;
  name: string;
  discountPercentage?: number;
  onClick: () => void;
  forceDarkTheme?: boolean;
  categoryName: string | null;
};

export function SimilarGcListingCard(props: SimilarGcListingCardProps) {
  const hasDiscount = () => (props.discountPercentage ?? 0) > 0;

  return (
    <div
      class="flex cursor-pointer flex-col gap-2"
      classList={{
        "telescope-dark-theme": props.forceDarkTheme,
      }}
      onClick={props.onClick}
    >
      {/* Image Container */}
      <div class="relative aspect-[312/348] w-full shrink-0 overflow-hidden rounded-xl">
        <img
          src={props.imageUrl}
          alt={props.name}
          class="absolute inset-0 size-full object-cover"
        />
      </div>

      {/* Brand Info */}
      <div class="flex w-full flex-col items-start px-1">
        {/* Brand Name */}
        <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-[10px] font-medium uppercase leading-3 tracking-[0.4px] text-text-normal-primary">
          {props.name}
        </div>

        <Show when={props.categoryName}>
          <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-label-medium text-text-normal-secondary">
            {props.categoryName}
          </div>
        </Show>

        {/* Discount Info */}
        <Show when={hasDiscount()}>
          <div class="flex items-center">
            <span class="text-[16px] font-medium leading-6 tracking-[-0.16px] text-success-base">
              {props.discountPercentage}
            </span>
            <span class="text-[12px] font-medium leading-4 tracking-[-0.12px] text-success-base">
              % off
            </span>
          </div>
        </Show>
      </div>
    </div>
  );
}
